import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Cargando...</div>;
}

const OtCalendarContainer = Loadable({
    loader: () => import('../../Containers/Ot/OtCalendarContainer'),
    loading: Loading,
});
const CreateOtContainer = Loadable({
    loader: () => import('../../Containers/Ot/CreateOtContainer'),
    loading: Loading,
});
const EditOtContainer = Loadable({
    loader: () => import('../../Containers/Ot/EditOtContainer'),
    loading: Loading,
});
const OtTableContainer = Loadable({
    loader: () => import('../../Containers/Ot/OtTableContainer'),
    loading: Loading,
});
const QuoteTableContainer = Loadable({
    loader: () => import('../../Containers/Ot/QuoteTableContainer'),
    loading: Loading,
});
const CreateQuoteContainer = Loadable({
    loader: () => import('../../Containers/Ot/CreateQuoteContainer'),
    loading: Loading,
});

const CreateQuickQuoteContainer = Loadable({
    loader: () => import('../../Containers/Ot/CreateQuickQuoteContainer'),
    loading: Loading,
});

const CreateQuickOtContainer = Loadable({
    loader: () => import('../../Containers/Ot/CreateQuickOtContainer'),
    loading: Loading,
});

const otRoutes = [
  { path: '/ot/calendar', exact: true, name: 'Calendario', component: OtCalendarContainer },
  { path: '/ot/create', exact: true, name: 'Crear OT', component: CreateOtContainer },
  { path: '/ot/:uuid/edit', exact: true, name: 'Editar OT', component: EditOtContainer },
  { path: '/ot/list', exact: true, name: 'Administración de Ordenes de Trabajo', component: OtTableContainer },
  { path: '/ot/quick-create', exact: true, name: 'Crear Orden de Trabajo', component: CreateQuickOtContainer },

  { path: '/quote/create', exact: true, name: 'Crear Cotización', component: CreateQuoteContainer },
  { path: '/quote/list', exact: true, name: 'Administración de Cotizaciones', component: QuoteTableContainer },
  { path: '/quote/quick-create', exact: true, name: 'Crear Cotización', component: CreateQuickQuoteContainer },
];

export default otRoutes;



// WEBPACK FOOTER //
// ./src/Routes/Modules/ot.js